import React, { useState } from "react";

const G = "#0077B5";

export default function TeamsUpsell({ onUpgradeToTeam }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onUpgradeToTeam();
    } catch (e) {
      setLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "60px auto", padding: "0 24px", textAlign: "center" }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>&#128101;</div>
      <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 8, fontFamily: "'Playfair Display',Georgia,serif" }}>
        Teams by <em style={{ color: G }}>BrandHives</em>
      </h1>
      <p style={{ fontSize: 17, color: "#555", marginBottom: 32, lineHeight: 1.6 }}>
        Automate LinkedIn for your entire team. Every member gets their own AI-powered posting schedule in their unique voice.
      </p>

      <div style={{ background: "#F3F2EF", border: "1px solid #E1E9EE", borderRadius: 12, padding: "28px 24px", marginBottom: 32, textAlign: "left" }}>
        <div style={{ display: "flex", gap: 24, marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 13, color: "#888", marginBottom: 2 }}>Starting from</div>
            <div style={{ fontSize: 32, fontWeight: 300 }}>
              $298<span style={{ fontSize: 14, color: "#888" }}>/mo</span>
            </div>
            <div style={{ fontSize: 13, color: "#666" }}>Authority Team</div>
            <div style={{ fontSize: 12, color: "#888" }}>$149/seat · min 2</div>
          </div>
          <div style={{ borderLeft: "1px solid #ddd" }} />
          <div>
            <div style={{ fontSize: 13, color: "#888", marginBottom: 2 }}>Starting from</div>
            <div style={{ fontSize: 32, fontWeight: 300 }}>
              $398<span style={{ fontSize: 14, color: "#888" }}>/mo</span>
            </div>
            <div style={{ fontSize: 13, color: "#666" }}>Authority Pro</div>
            <div style={{ fontSize: 12, color: "#888" }}>$199/seat · min 2</div>
          </div>
        </div>
        <div style={{ fontSize: 14, color: "#666", marginBottom: 20 }}>
          Minimum 2 seats. Add more anytime at the per-seat rate.
        </div>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {[
            "Every team member gets their own LinkedIn schedule",
            "Posts written in each person\u2019s unique voice",
            "One weekly plug post for the whole team",
            "Centralized billing \u2014 members never see costs",
            "Full analytics across your entire team",
            "Workgroup management with admin controls",
          ].map((f, i) => (
            <li key={i} style={{ padding: "6px 0", fontSize: 15, color: "#333", display: "flex", alignItems: "flex-start", gap: 10 }}>
              <span style={{ color: G, fontWeight: 700, flexShrink: 0 }}>&#10003;</span>
              {f}
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={() => setShowConfirm(true)}
        style={{
          padding: "14px 36px", fontSize: 17, fontWeight: 700,
          backgroundColor: G, color: "white", border: "none",
          borderRadius: 8, cursor: "pointer", minWidth: 220,
        }}
      >
        Start my team
      </button>
      <div style={{ marginTop: 16, fontSize: 13, color: "#888" }}>
        First month non-refundable. Cancel anytime after.
      </div>

      {showConfirm && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: "white", borderRadius: 12, padding: 32,
            maxWidth: 480, width: "90%", textAlign: "left",
          }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>
              Before you continue
            </h2>
            <p style={{ fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
              <strong>BrandHives Team — per-seat pricing</strong>
            </p>
            <p style={{ fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
              Authority Team: from $298/mo ($149/seat, min 2). Authority Pro: from $398/mo ($199/seat, min 2).
            </p>
            <p style={{ fontSize: 15, lineHeight: 1.6, marginBottom: 12, color: "#B91C1C", fontWeight: 600 }}>
              The first month is non-refundable.
            </p>
            <p style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 24, color: "#555" }}>
              You can cancel anytime to prevent future charges, but the first month is non-refundable.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowConfirm(false)}
                disabled={loading}
                style={{
                  padding: "10px 20px", fontSize: 15, fontWeight: 600,
                  backgroundColor: "transparent", color: "#555",
                  border: "1px solid #ddd", borderRadius: 6, cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={loading}
                style={{
                  padding: "10px 20px", fontSize: 15, fontWeight: 600,
                  backgroundColor: G, color: "white",
                  border: "none", borderRadius: 6,
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? "Redirecting..." : "Continue to payment"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
